__turbopack_context__.v({
  "brandSection": "footer-module-scss-module__Wscpia__brandSection",
  "brandSectionCopy": "footer-module-scss-module__Wscpia__brandSectionCopy",
  "brandSectionLogo": "footer-module-scss-module__Wscpia__brandSectionLogo",
  "brandSectionSocial": "footer-module-scss-module__Wscpia__brandSectionSocial",
  "container": "footer-module-scss-module__Wscpia__container",
  "footer": "footer-module-scss-module__Wscpia__footer",
  "grid": "footer-module-scss-module__Wscpia__grid",
});
